import getMatches from './getMatches'
import saveMitigator from './saveMitigator'

export const getMatchesPromise = getMatches
export const saveMitigatorPromise = saveMitigator
